import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { SolarHome2BoldDuotone } from '@solar-icons/angular/home-2-bold-duotone';
import { SolarNotesBoldDuotone } from '@solar-icons/angular/notes-bold-duotone';
import { SolarPen2BoldDuotone } from '@solar-icons/angular/pen-2-bold-duotone';
import { SolarChecklistBoldDuotone } from '@solar-icons/angular/checklist-bold-duotone';
import { SolarPlayCircleBoldDuotone } from '@solar-icons/angular/play-circle-bold-duotone';
import { SolarHistoryBoldDuotone } from '@solar-icons/angular/history-bold-duotone';
import { SolarVideocameraBoldDuotone } from '@solar-icons/angular/videocamera-bold-duotone';
import { SolarCardSearchBoldDuotone } from '@solar-icons/angular/card-search-bold-duotone';
import { SolarStopwatchBoldDuotone } from '@solar-icons/angular/stopwatch-bold-duotone';
import { SolarBoxBoldDuotone } from '@solar-icons/angular/box-bold-duotone';
import { SolarDocumentTextBoldDuotone } from '@solar-icons/angular/document-text-bold-duotone';
import { SolarFileCheckBoldDuotone } from '@solar-icons/angular/file-check-bold-duotone';
import { SolarHistory3BoldDuotone } from '@solar-icons/angular/history-3-bold-duotone';
import { SolarUserSpeakBoldDuotone } from '@solar-icons/angular/user-speak-bold-duotone';
import { SolarChartSquareBoldDuotone } from '@solar-icons/angular/chart-square-bold-duotone';
import { SolarUsersGroupTwoRoundedBoldDuotone } from '@solar-icons/angular/users-group-two-rounded-bold-duotone';
import { SolarPenNewSquareBoldDuotone } from '@solar-icons/angular/pen-new-square-bold-duotone';
import { SolarQuestionSquareBoldDuotone } from '@solar-icons/angular/question-square-bold-duotone';
import { SolarDocumentBoldDuotone } from '@solar-icons/angular/document-bold-duotone';
import { SolarVideocameraAddBoldDuotone } from '@solar-icons/angular/videocamera-add-bold-duotone';
import { SolarVideoFramePlayHorizontalBoldDuotone } from '@solar-icons/angular/video-frame-play-horizontal-bold-duotone';
import { SolarGalleryBoldDuotone } from '@solar-icons/angular/gallery-bold-duotone';
import { SolarTagPriceBoldDuotone } from '@solar-icons/angular/tag-price-bold-duotone';
import { SolarCard2BoldDuotone } from '@solar-icons/angular/card-2-bold-duotone';
import { SolarUsersGroupRoundedBoldDuotone } from '@solar-icons/angular/users-group-rounded-bold-duotone';
import { SolarStructureBoldDuotone } from '@solar-icons/angular/structure-bold-duotone';
import { SolarTagBoldDuotone } from '@solar-icons/angular/tag-bold-duotone';

interface CustomMenuItem extends MenuItem {
    solarIcon?: any;
    access?: string[];
    items?: CustomMenuItem[];
}

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu {
    model: MenuItem[] = [];
    user: any = null;
    idAccessRole: string = '';

    ngOnInit() {
        const userStr = localStorage.getItem('user');
        if (userStr) {
            try {
                this.user = JSON.parse(userStr) || {};
                this.idAccessRole = this.user.ID_ACCESS_ROLE || '';
            } catch {
                this.user = {};
                this.idAccessRole = '';
            }
        }
        const fullModel: CustomMenuItem[] = [
            // === BERANDA ===
            {
                label: 'Dashboard',
                icon: 'pi pi-fw pi-th-large',
                items: [
                    {
                        label: 'Beranda',
                        solarIcon: SolarHome2BoldDuotone,
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/app/dashboard'],
                        access: ['4AEJ1KAJTY', 'HAGSJ76H98', 'N2FWBVCZUE']
                    },
                    {
                        label: 'Catatan Saya',
                        solarIcon: SolarNotesBoldDuotone,
                        icon: 'pi pi-fw pi-book',
                        routerLink: ['/app/notes'],
                        access: ['HAGSJ76H98', 'N2FWBVCZUE']
                    },
                ]
            },

            // === PEMBELAJARAN & PRAKTEK ===
            {
                label: 'Pembelajaran & Praktek',
                icon: 'pi pi-fw pi-graduation-cap',
                items: [
                    {
                        label: 'Latihan Penunjang',
                        solarIcon: SolarPen2BoldDuotone,
                        icon: 'pi pi-fw pi-question-circle',
                        routerLink: ['/app/quiz'],
                        access: ['HAGSJ76H98']
                    },
                    {
                        label: 'Checklist OSCE',
                        solarIcon: SolarChecklistBoldDuotone,
                        icon: 'pi pi-fw pi-file-edit',
                        routerLink: ['/app/osce/tutor'],
                        access: ['HAGSJ76H98']
                    },
                    {
                        label: 'Simulasi OSCE (Stase RME)',
                        solarIcon: SolarPlayCircleBoldDuotone,
                        icon: 'pi pi-fw pi-play',
                        routerLink: ['/app/osce/simulation'],
                        access: ['HAGSJ76H98']
                    },
                    {
                        label: 'Riwayat Simulasi',
                        solarIcon: SolarHistoryBoldDuotone,
                        icon: 'pi pi-fw pi-history',
                        routerLink: ['/app/osce/simulation/history'],
                        access: ['HAGSJ76H98']
                    },
                    {
                        label: 'Video Material',
                        solarIcon: SolarVideocameraBoldDuotone,
                        icon: 'pi pi-fw pi-video',
                        routerLink: ['/app/video_material/list'],
                        access: ['HAGSJ76H98', 'N2FWBVCZUE']
                    },
                    {
                        label: 'Flashcard',
                        solarIcon: SolarCardSearchBoldDuotone,
                        icon: 'pi pi-fw pi-clone',
                        routerLink: ['/app/flashcard/show'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Artikel',
                        solarIcon: SolarDocumentTextBoldDuotone,
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/app/article/list'],
                        access: ['HAGSJ76H98', 'N2FWBVCZUE']
                    },
                ]
            },

            // === UJIAN & EVALUASI ===
            {
                label: 'Ujian & Evaluasi',
                icon: 'pi pi-fw pi-bookmark',
                items: [
                    {
                        label: 'Timer Ujian',
                        solarIcon: SolarStopwatchBoldDuotone,
                        icon: 'pi pi-fw pi-clock',
                        routerLink: ['/app/osce/timer'],
                        access: ['4AEJ1KAJTY', 'HAGSJ76H98', 'N2FWBVCZUE']
                    },
                    {
                        label: 'Paket OSCE',
                        solarIcon: SolarBoxBoldDuotone,
                        icon: 'pi pi-fw pi-box',
                        routerLink: ['/app/osce/packages'],
                        access: ['4AEJ1KAJTY', 'N2FWBVCZUE']
                    },
                    {
                        label: 'Riwayat Jawaban',
                        solarIcon: SolarDocumentTextBoldDuotone,
                        icon: 'pi pi-fw pi-file-edit',
                        routerLink: ['/app/osce/form/answer/history'],
                        access: ['HAGSJ76H98']
                    },
                    {
                        label: 'Riwayat OSCE',
                        solarIcon: SolarFileCheckBoldDuotone,
                        icon: 'pi pi-fw pi-file-excel',
                        routerLink: ['/app/osce/sheet/history'],
                        access: ['HAGSJ76H98']
                    },
                    {
                        label: 'Riwayat Checklist OSCE',
                        solarIcon: SolarHistory3BoldDuotone,
                        icon: 'pi pi-fw pi-history',
                        routerLink: ['/app/osce/tutor/history'],
                        access: ['4AEJ1KAJTY', 'HAGSJ76H98', 'N2FWBVCZUE']
                    },
                ]
            },

            // === PENGELOLAAN KONTEN ===
            {
                label: 'Pengelolaan Konten',
                icon: 'pi pi-fw pi-briefcase',
                items: [
                    {
                        label: 'Tutor & Pembimbing',
                        solarIcon: SolarUserSpeakBoldDuotone,
                        icon: 'pi pi-fw pi-user-edit',
                        routerLink: ['/app/osce/tutor'],
                        access: ['4AEJ1KAJTY', 'N2FWBVCZUE']
                    },
                    {
                        label: 'Hasil & Laporan',
                        solarIcon: SolarChartSquareBoldDuotone,
                        icon: 'pi pi-fw pi-chart-bar',
                        routerLink: ['/app/osce/result'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Riwayat Checklist Peserta',
                        solarIcon: SolarUsersGroupTwoRoundedBoldDuotone,
                        icon: 'pi pi-fw pi-history',
                        routerLink: ['/app/osce/result/participant-history'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola Formulir',
                        solarIcon: SolarPenNewSquareBoldDuotone,
                        icon: 'pi pi-fw pi-pencil',
                        routerLink: ['/app/osce/form'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola Kuis',
                        solarIcon: SolarQuestionSquareBoldDuotone,
                        icon: 'pi pi-fw pi-file-edit',
                        routerLink: ['/app/osce/form/ekg'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola OSCE',
                        solarIcon: SolarDocumentBoldDuotone,
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/app/osce/sheet/cases'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola Video Material',
                        solarIcon: SolarVideocameraAddBoldDuotone,
                        icon: 'pi pi-fw pi-video',
                        routerLink: ['/app/video_material'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola Artikel',
                        solarIcon: SolarDocumentTextBoldDuotone,
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/app/article'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola Testimoni Video',
                        solarIcon: SolarVideoFramePlayHorizontalBoldDuotone,
                        icon: 'pi pi-fw pi-play-circle',
                        routerLink: ['/app/testimonies/video'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola Testimoni Gambar',
                        solarIcon: SolarGalleryBoldDuotone,
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['/app/testimonies/image'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola Flashcard Kategori',
                        solarIcon: SolarTagPriceBoldDuotone,
                        icon: 'pi pi-fw pi-tags',
                        routerLink: ['/app/flashcard'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola Flashcard',
                        solarIcon: SolarCard2BoldDuotone,
                        icon: 'pi pi-fw pi-question-circle',
                        routerLink: ['/app/flashcards'],
                        access: ['N2FWBVCZUE']
                    },
                ]
            },

            // === ADMINISTRASI SISTEM ===
            {
                label: 'Administrasi Sistem',
                icon: 'pi pi-fw pi-cog',
                items: [
                    {
                        label: 'Kelola Pengguna',
                        solarIcon: SolarUsersGroupRoundedBoldDuotone,
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/app/users'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola Bagian',
                        solarIcon: SolarStructureBoldDuotone,
                        icon: 'pi pi-fw pi-sitemap',
                        routerLink: ['/app/sections'],
                        access: ['N2FWBVCZUE']
                    },
                    {
                        label: 'Kelola Kategori',
                        solarIcon: SolarTagBoldDuotone,
                        icon: 'pi pi-fw pi-tags',
                        routerLink: ['/app/categories'],
                        access: ['N2FWBVCZUE']
                    },
                ]
            },
        ];
        this.model = fullModel
            .map(menu => {
                if (!Array.isArray(menu.items)) return { ...menu, items: [] };

                const allowed = menu.items.filter(item =>
                    item.separator || (Array.isArray(item.access) && item.access.includes(this.idAccessRole))
                );

                const cleanedItems: CustomMenuItem[] = [];
                for (let i = 0; i < allowed.length; i++) {
                    const current = allowed[i];
                    if (current.separator) {
                        const hasPrevItem = cleanedItems.length > 0 && !cleanedItems[cleanedItems.length - 1].separator;
                        const hasNextItem = allowed.slice(i + 1).some(x => !x.separator);
                        if (hasPrevItem && hasNextItem) {
                            cleanedItems.push(current);
                        }
                    } else {
                        cleanedItems.push(current);
                    }
                }
                return { ...menu, items: cleanedItems };
            })
            .filter(menu => menu.items && menu.items.length > 0);
    }
}
